(function () {
  'use strict';

  // Adds an inline add-on to the cart without leaving the page.
  //
  // Deliberately does NOT open the cart drawer. Ride's own product form calls
  // cart.renderContents(), which both refreshes and opens it — fine for the main
  // add to cart, wrong here: the shopper is still configuring the product above,
  // and throwing the drawer over that interrupts the purchase they came for.
  // Instead the cart count updates in place and the button confirms.
  //
  // Progressive enhancement: without this script the form does a normal POST to
  // /cart/add and the shopper lands on the cart page. Slightly worse, never
  // broken.
  class SpikeyAddonForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      if (!this.form || !this.button) return;

      this.defaultLabel = this.button.textContent.trim();
      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.resetTimer) clearTimeout(this.resetTimer);
    }

    onSubmit(event) {
      // fetchConfig comes from Ride's global.js. If it is missing for any
      // reason, let the browser submit normally rather than swallowing the click.
      if (typeof fetchConfig !== 'function' || typeof routes === 'undefined') return;

      event.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      this.button.setAttribute('aria-disabled', 'true');
      this.setLabel(this.button.dataset.addingLabel || 'Adding…');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      // Ask for the cart sections back so the count can be refreshed without a
      // second request.
      formData.append('sections', 'cart-icon-bubble,cart-drawer');
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      var self = this;
      fetch(routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            // Shopify returns a status on failure, e.g. sold out mid-session.
            self.setLabel(self.button.dataset.errorLabel || 'Unavailable');
            self.resetLater(2500);
            return;
          }
          self.refreshCart(response.sections);
          self.setLabel(self.button.dataset.addedLabel || 'Added');
          self.resetLater(2000);
        })
        .catch(function () {
          self.setLabel(self.button.dataset.errorLabel || 'Try again');
          self.resetLater(2500);
        });
    }

    setLabel(text) {
      this.button.textContent = text;
    }

    resetLater(ms) {
      var self = this;
      if (this.resetTimer) clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(function () {
        self.setLabel(self.defaultLabel);
        self.button.removeAttribute('aria-disabled');
      }, ms);
    }

    refreshCart(sections) {
      if (!sections) return;

      // Cart count in the header.
      var bubbleHtml = sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleHtml && bubble) {
        var parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var fresh = parsed.querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }

      // Drawer contents, so it is correct whenever the shopper does open it.
      // Mirrors cart-drawer.js getSectionsToRender(): the cart-drawer section is
      // read and written through #CartDrawer, not the <cart-drawer> element.
      var drawerHtml = sections['cart-drawer'];
      var drawerInner = document.querySelector('#CartDrawer');
      if (drawerHtml && drawerInner) {
        var parsedDrawer = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var freshDrawer = parsedDrawer.querySelector('#CartDrawer');
        if (freshDrawer) drawerInner.innerHTML = freshDrawer.innerHTML;
      }

      // The cart is definitely non-empty after a successful add. Ride carries
      // is-empty on both the <cart-drawer> element (cart-drawer.js:38) and on
      // .drawer__inner (cart-drawer.js:72), so clear it from both or the drawer
      // opens showing its empty state despite having items.
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
      var inner = document.querySelector('cart-drawer .drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
  }

  if (!customElements.get('spikey-addon-form')) {
    customElements.define('spikey-addon-form', SpikeyAddonForm);
  }
})();
